import { render } from "./PlatMenu.vue?vue&type=template&id=528c1dfe&scoped=true"
import script from "./PlatMenu.vue?vue&type=script&lang=js"
export * from "./PlatMenu.vue?vue&type=script&lang=js"

import "./PlatMenu.vue?vue&type=style&index=0&id=528c1dfe&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528c1dfe"]])

export default __exports__